import {Component, OnInit} from '@angular/core';
import {AbstractFields} from '../_abstract';
import {WizardEnums} from '../../wizard.namespace';
import {LaboratoryDocumentsProvider} from '@providers/laboratory-documents/laboratory-documents.provider';
import {AuthService} from '@services/auth.service';
import {UserNamespace} from '@namespaces/user.namespace';

/* Поля шага визарда "Тип лаборатории" */
@Component({
    selector: 'laboratory-type-fields',
    templateUrl: './laboratory-type.component.html'
})
export class LaboratoryTypeFieldsComponent extends AbstractFields implements OnInit {

    public laboratoryTypes = WizardEnums.LaboratoryTypes;
    public documentsTypes = WizardEnums.DocumentsTypes;
    public laboratoryAttestationTypes = WizardEnums.LaboratoryAttestationTypes;

    public canAddDocuments = false;

    constructor(
        public laboratoryDocumentsProvider: LaboratoryDocumentsProvider,
        private authService: AuthService,
    ) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();

        this.canAddDocuments = this.authService.hasPermissions([UserNamespace.Permission.structureUnitDocumentCreate]);
    }
}
